export default {
    "CustomerPdf": ["Invoice"],
    "GaragePdf": ["Invoice"],
    "CustomerEmail": ["DamageAdded", "NewOffer", "NewTurboOffer", "NewCounterOffer", "OfferAccepted", "OrderConfirmation", "Invoice"],
    "GarageEmail": ["SentOffer", "OfferAccepted", "Invoice", "Payout"],
};
  